/* (c) Copyright Frontify Ltd., all rights reserved. */

export const ON_SAVE_DELAY_IN_MS = 500;
export const OFFSET_IN_PX = 16;
